<div class="abu-modal">
  <div class="abu-modal__header">
    <div class="abu-modal__title-group">
      <h4 class="abu-modal__title">{{ title }}</h4>
      <p class="abu-modal__subtitle">{{ subtitle }}</p>
    </div>
    <button type="button" class="abu-modal__close-btn" (click)="activeModal.dismiss('Cross click')">
      <i data-lucide="x"></i>
    </button>
  </div>

  <div class="abu-modal__body" *ngIf="step === 'upload'">
    <div class="abu-upload-panel" *ngIf="!loadingLookups; else loadingTpl">
      <div class="abu-actions-row">
        <button type="button" class="btn btn--outline" (click)="downloadTemplate('xlsx')">
          <i data-lucide="download"></i>
          Download Excel (.xlsx)
        </button>
        <button type="button" class="btn btn--outline" (click)="downloadTemplate('csv')">
          <i data-lucide="download"></i>
          Download CSV
        </button>
        <label class="btn btn--primary abu-file-label">
          <i data-lucide="upload"></i>
          Select File (.xlsx / .csv)
          <input type="file" accept=".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" class="d-none" (change)="onFileSelected($event)" [disabled]="parsing" />
        </label>
      </div>

      <p class="abu-hint" *ngIf="fileName">Selected: {{ fileName }}</p>
      <p class="abu-error" *ngIf="fileError">{{ fileError }}</p>
      <p class="abu-hint" *ngIf="parsing">Parsing file…</p>

      <div class="abu-help">
        <p>Required columns depend on entity type. Optional lookup columns can be left blank and filled via dropdowns in preview.</p>
        <ul *ngIf="isRecipe">
          <li><strong>RecipeName*</strong>, <strong>Source*</strong>, <strong>Description*</strong></li>
          <li>Alias / OriginalName, AlternateName (optional)</li>
        </ul>
        <ul *ngIf="!isRecipe">
          <li><strong>BrandName*</strong>, <strong>ProductName*</strong></li>
          <li>DataSource, DatabaseSource, CountryOfOrigin (optional — select in preview)</li>
        </ul>
        <p>Maximum {{ maxRows }} rows per file. Created items land in <strong>To be assigned</strong>.</p>
      </div>
    </div>
    <ng-template #loadingTpl>
      <p class="abu-hint">Loading master data for validation…</p>
    </ng-template>
  </div>

  <div class="abu-modal__body" *ngIf="step === 'preview'">
    <div class="abu-summary">
      <span class="abu-badge abu-badge--total">Total: {{ totalCount }}</span>
      <span class="abu-badge abu-badge--valid">Valid: {{ validCount }}</span>
      <span class="abu-badge abu-badge--error">Errors: {{ errorCount }}</span>
    </div>

    <div class="abu-table-container">
      <table class="abu-table" *ngIf="isRecipe">
        <thead>
          <tr>
            <th>#</th>
            <th>Recipe Name *</th>
            <th>Source *</th>
            <th>Description *</th>
            <th>Alias</th>
            <th>Alternate Name</th>
            <th>Status</th>
            <th *ngIf="errorCount > 0">Error</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of parseResult?.rows; let i = index" [class.abu-row--error]="!row.valid">
            <td>{{ row.rowNumber }}</td>
            <td class="abu-text-cell">{{ row.display.RecipeName || '—' }}</td>
            <td class="abu-select-cell">
              <ng-select
                [items]="sourceOptions"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Source"
                [(ngModel)]="row.selections.sourceId"
                (ngModelChange)="onSourceChange(row)"
                [clearable]="true"
                appendTo="body"
                class="abu-ng-select"
              ></ng-select>
            </td>
            <td class="abu-text-cell">{{ row.display.Description || '—' }}</td>
            <td class="abu-text-cell">{{ row.display.OriginalName || '—' }}</td>
            <td class="abu-text-cell">{{ row.display.AlternateName || '—' }}</td>
            <td>
              <span class="abu-status" [class.abu-status--valid]="row.valid" [class.abu-status--error]="!row.valid">
                {{ row.valid ? 'Valid' : 'Error' }}
              </span>
            </td>
            <td class="abu-error-cell" *ngIf="errorCount > 0">{{ row.error || '—' }}</td>
            <td class="abu-action-cell">
              <button type="button" class="abu-delete-btn" title="Delete row" (click)="deleteRow(i)">
                <i data-lucide="trash-2" style="width:12px;height:12px;margin:0;"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="abu-table" *ngIf="!isRecipe">
        <thead>
          <tr>
            <th>#</th>
            <th>Brand Name *</th>
            <th>Product Name *</th>
            <th>Data Source</th>
            <th>Database Source</th>
            <th>Country Of Origin</th>
            <th>Status</th>
            <th *ngIf="errorCount > 0">Error</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of parseResult?.rows; let i = index" [class.abu-row--error]="!row.valid">
            <td>{{ row.rowNumber }}</td>
            <td class="abu-text-cell">{{ row.display.BrandName || '—' }}</td>
            <td class="abu-text-cell">{{ row.display.ProductName || '—' }}</td>
            <td class="abu-select-cell">
              <ng-select
                [items]="dataSourceOptions"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Data Source"
                [(ngModel)]="row.selections.dataSourceId"
                (ngModelChange)="onProductLookupChange(row)"
                [clearable]="true"
                appendTo="body"
                class="abu-ng-select"
              ></ng-select>
            </td>
            <td class="abu-select-cell">
              <ng-select
                [items]="databaseSourceOptions"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Database Source"
                [(ngModel)]="row.selections.databaseSourceId"
                (ngModelChange)="onProductLookupChange(row)"
                [clearable]="true"
                appendTo="body"
                class="abu-ng-select"
              ></ng-select>
            </td>
            <td class="abu-select-cell">
              <ng-select
                [items]="countryOptions"
                bindLabel="name"
                bindValue="id"
                placeholder="Select Country"
                [(ngModel)]="row.selections.countryOfOriginId"
                (ngModelChange)="onProductLookupChange(row)"
                [clearable]="true"
                appendTo="body"
                class="abu-ng-select"
              ></ng-select>
            </td>
            <td>
              <span class="abu-status" [class.abu-status--valid]="row.valid" [class.abu-status--error]="!row.valid">
                {{ row.valid ? 'Valid' : 'Error' }}
              </span>
            </td>
            <td class="abu-error-cell" *ngIf="errorCount > 0">{{ row.error || '—' }}</td>
            <td class="abu-action-cell">
              <button type="button" class="abu-delete-btn" title="Delete row" (click)="deleteRow(i)">
                <i data-lucide="trash-2" style="width:12px;height:12px;margin:0;"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="abu-modal__footer">
    <button type="button" class="btn btn--outline" (click)="activeModal.dismiss('Cancel click')">
      Cancel
    </button>
    <button type="button" class="btn btn--outline" *ngIf="step === 'preview'" (click)="backToUpload()">
      Back
    </button>
    <button
      type="button"
      class="btn btn--primary"
      *ngIf="step === 'preview'"
      [disabled]="validCount === 0"
      (click)="confirmImport()"
    >
      <i data-lucide="check"></i>
      Confirm Import ({{ validCount }})
    </button>
  </div>
</div>
